import React from 'react';
import AppAvatar from '../Avatar/AppAvatar';
import clsx from 'clsx';
import deepOrange from '@material-ui/core/colors/deepOrange';
import type { AppAvatarProps } from '../Avatar/AppAvatar';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 80,
    height: 80,
    margin: 'auto',
    borderRadius: theme.shape.borderRadius,
    [theme.breakpoints.up('sm')]: {
      width: 60,
      height: 60,
      margin: 'unset',
    },
  },
  noImage: {
    color: theme.palette.common.white,
    backgroundColor: deepOrange[400],
  },
}));

const Logo = ({
  src,
  loaded,
  alt,
  className,
  ...otherProps
}: AppAvatarProps) => {
  const classes = useStyles();

  return (
    <AppAvatar
      {...otherProps}
      src={src}
      alt={alt}
      loaded={loaded}
      variant={src ? 'rounded' : 'circular'}
      className={clsx(
        classes.root,
        !src && loaded && classes.noImage,
        className,
      )}
    >
      {alt?.[0] || undefined}
    </AppAvatar>
  );
};

export default Logo;
